import type { ISerialize } from '@/objects/ISerialize';

export class DeviceBattery implements ISerialize {
    public IsActive: boolean;

    public IsPresent: boolean;

    public PowerLevel: number | null;

    public Voltage: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { IsActive?: boolean; IsPresent?: boolean; PowerLevel?: number | null; Voltage?: number | null }) {
        this.IsActive = values.IsActive ?? false;

        this.IsPresent = values.IsPresent ?? false;

        this.PowerLevel = values.PowerLevel ?? null;

        this.Voltage = values.Voltage ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"IsActive": ${JSON.stringify(this.IsActive)}` +
            ',' +
            `"IsPresent": ${JSON.stringify(this.IsPresent)}` +
            ',' +
            `"PowerLevel": ${JSON.stringify(this.PowerLevel)}` +
            ',' +
            `"Voltage": ${JSON.stringify(this.Voltage)}` +
            '}'
        );
    }

    /**
     * Creates an instance of DeviceBattery from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        IsActive?: boolean;
        IsPresent?: boolean;
        PowerLevel?: number | null;
        Voltage?: number | null;
    }): DeviceBattery {
        return new DeviceBattery(values);
    }

    public static _FromServerJson(json: any): DeviceBattery {
        return new DeviceBattery({
            IsActive: json.IsActive,
            IsPresent: json.IsPresent,
            PowerLevel: json.PowerLevel ?? null,
            Voltage: json.Voltage ?? null,
        });
    }

    /**
     * Creates an instance of DeviceBattery from another instance of DeviceBattery.
     * @param other The DeviceBattery you want to clone
     * @returns A cloned DeviceBattery
     */
    public static FromOther(other: DeviceBattery): DeviceBattery {
        return DeviceBattery._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DeviceBattery.FromOther(this);
    }

    static NAME_OF_CLASS = 'DeviceBattery';
}
